import { styled } from 'linaria/react';
import theme from '@clad-ui/theme';
const {
  mediaQueries,
  breakpoints
} = theme;

/**
 * @type {any}
 */
const StyledCol = /*#__PURE__*/styled("div")({
  name: "StyledCol",
  class: "spa2iur",
  vars: {
    "spa2iur-0": [({
      alignSelf
    }) => alignSelf],
    "spa2iur-1": [({
      colOrder
    }) => colOrder],
    "spa2iur-2": [({
      spans
    }) => spans[0]],
    "spa2iur-4": [({
      offsets
    }) => offsets[0]],
    "spa2iur-6": [({
      spans
    }) => spans[1]],
    "spa2iur-8": [({
      offsets
    }) => offsets[1]],
    "spa2iur-10": [({
      spans
    }) => spans[2]],
    "spa2iur-12": [({
      offsets
    }) => offsets[2]],
    "spa2iur-14": [({
      spans
    }) => spans[3]],
    "spa2iur-16": [({
      offsets
    }) => offsets[3]],
    "spa2iur-18": [({
      spans
    }) => spans[4]],
    "spa2iur-20": [({
      offsets
    }) => offsets[4]]
  }
});

/**
 * @type {any}
 */
const StyledGrid = /*#__PURE__*/styled("div")({
  name: "StyledGrid",
  class: "sy64i72",
  vars: {
    "sy64i72-0": [({
      alignItems
    }) => alignItems],
    "sy64i72-1": [({
      justifyContent
    }) => justifyContent],
    "sy64i72-3": [({
      colWidths
    }) => colWidths[0]],
    "sy64i72-6": [({
      colWidths
    }) => colWidths[1]],
    "sy64i72-9": [({
      colWidths
    }) => colWidths[2]],
    "sy64i72-12": [({
      colWidths
    }) => colWidths[3]],
    "sy64i72-15": [({
      colWidths
    }) => colWidths[4]]
  }
});

/**
 * @type {React.FC<any>}
 */
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "cybh37o",
  vars: {
    "cybh37o-0": [({
      containerWidths
    }) => containerWidths[0]],
    "cybh37o-1": [({
      gutterxs
    }) => gutterxs[0] / 2, "px"],
    "cybh37o-4": [({
      gutterys
    }) => gutterys[0] * -1, "px"],
    "cybh37o-5": [({
      gutterxs
    }) => gutterxs[0] * -1, "px"],
    "cybh37o-9": [({
      gutterys
    }) => gutterys[0], "px"],
    "cybh37o-13": [({
      containerWidths
    }) => containerWidths[1]],
    "cybh37o-14": [({
      gutterxs
    }) => gutterxs[1] / 2, "px"],
    "cybh37o-17": [({
      gutterys
    }) => gutterys[1] * -1, "px"],
    "cybh37o-18": [({
      gutterxs
    }) => gutterxs[1] * -1, "px"],
    "cybh37o-22": [({
      gutterys
    }) => gutterys[1], "px"],
    "cybh37o-26": [({
      containerWidths
    }) => containerWidths[2]],
    "cybh37o-27": [({
      gutterxs
    }) => gutterxs[2] / 2, "px"],
    "cybh37o-30": [({
      gutterys
    }) => gutterys[2] * -1, "px"],
    "cybh37o-31": [({
      gutterxs
    }) => gutterxs[2] * -1, "px"],
    "cybh37o-35": [({
      gutterys
    }) => gutterys[2], "px"],
    "cybh37o-39": [({
      containerWidths
    }) => containerWidths[3]],
    "cybh37o-40": [({
      gutterxs
    }) => gutterxs[3] / 2, "px"],
    "cybh37o-43": [({
      gutterys
    }) => gutterys[3] * -1, "px"],
    "cybh37o-44": [({
      gutterxs
    }) => gutterxs[3] * -1, "px"],
    "cybh37o-48": [({
      gutterys
    }) => gutterys[3], "px"],
    "cybh37o-52": [({
      containerWidths
    }) => containerWidths[4]],
    "cybh37o-53": [({
      gutterxs
    }) => gutterxs[4] / 2, "px"],
    "cybh37o-56": [({
      gutterys
    }) => gutterys[4] * -1, "px"],
    "cybh37o-57": [({
      gutterxs
    }) => gutterxs[4] * -1, "px"],
    "cybh37o-61": [({
      gutterys
    }) => gutterys[4], "px"]
  }
});
export { Container, StyledGrid, StyledCol };

require("../../../../../../../.linaria-cache/node_modules/.pnpm/clad-ui@0.20.20_mlt2zq6sucawkuesenn26jlwdu/node_modules/clad-ui/components/Grid/Grid.styles.linaria.module.css");